import replyIcon from "src/Assets/images/message new icon.png";

export default function ReplySvg() {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
      <img src={replyIcon} alt="Reply" style={{margin: "2px 0px 0px 10px", height: "20px"}}/>
      <span
        style={{
          fontSize: "14px",
          color: "#373334",
          lineHeight: 1,
        }}
      >
        Replies
      </span>
    </span>
  );
}
